/**
 * styles/variables.scssと同じ値をjsでも利用できるようにした定数ファイル
 * 本来は同期して作成できるようにしたいが、今は手動で作成。
 */

// カラーマップ
export const NP_COLOR_MAP = {
  primary: '#0092cc',
  warning: '#cc853d',
  error: '#d13f57',
  black: '#222',
  white: '#fff',
  burnt: '#6c7882',
  border: '#e1e2e5',
  column: '#ebedf0',
} as const;
